export default {"src":"/_next/static/media/close-dark.b5117864.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};